import ScopeChangeRequest from 'admin/scope-change-requests/ScopeChangeRequest'
import ScopeChangeRequestStore from 'admin/ScopeChangeRequestStore'
import ModalViewModel from 'infra/ModalViewModel'
import { action, makeObservable, observable } from 'mobx'
import { task } from 'mobx-task'

export const enum ScopeChangeRequestActionType {
  ApproveAsAdmin = 'ApproveAsAdmin',
  ApproveOnBehalfOfClient = 'ApproveOnBehalfOfClient',
}

export default class ScopeChangeRequestActionSelectionDialogViewModel extends ModalViewModel {
  @observable scopeChangeRequest = ScopeChangeRequest.none

  @observable
  actionType = ScopeChangeRequestActionType.ApproveAsAdmin

  constructor(
    private scopeChangeRequestStore: ScopeChangeRequestStore,
    private refreshStatusFilter: () => Promise<void>,
    private onSave: () => void,
  ) {
    super()
    makeObservable(this)
  }

  setAction(actionType: ScopeChangeRequestActionType) {
    this.actionType = actionType
  }

  @action
  open(scopeChangeRequest: ScopeChangeRequest) {
    this.scopeChangeRequest = scopeChangeRequest

    this.actionType =
      scopeChangeRequest.price > 0
        ? ScopeChangeRequestActionType.ApproveAsAdmin
        : ScopeChangeRequestActionType.ApproveOnBehalfOfClient

    this.show()
  }

  submit = task.resolved(async () => {
    const skipClientApproval =
      this.actionType === ScopeChangeRequestActionType.ApproveOnBehalfOfClient

    await this.scopeChangeRequestStore.approveScopeChangeRequest(
      this.scopeChangeRequest,
      skipClientApproval,
    )

    if (skipClientApproval) {
      await this.refreshStatusFilter()
    }

    this.onSave()
    this.close()
  })
}
